export default {"src":"/assets/_next/static/media/en.0db8b001.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};